import {
  CustomizationSelectedIngredient,
  CustomizationSelectedIngredientKindSection,
  CustomizationSelectedIngredientsContainer,
  CustomizationSelectedIngredientsList,
  CustomizationSelectedIngredientsListItem,
} from './components';

export const CustomizationSelectedIngredients = {
  Container: CustomizationSelectedIngredientsContainer,
  List: CustomizationSelectedIngredientsList,
  ListItem: CustomizationSelectedIngredientsListItem,
  Ingredient: CustomizationSelectedIngredient,
  IngredientKindSection: CustomizationSelectedIngredientKindSection,
};
